import { render } from "./grading.vue?vue&type=template&id=713a9d90&scoped=true"
import script from "./grading.vue?vue&type=script&lang=js"
export * from "./grading.vue?vue&type=script&lang=js"

import "./grading.vue?vue&type=style&index=0&id=713a9d90&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713a9d90"]])

export default __exports__